import React, { memo } from 'react';

import PropTypes from 'prop-types';

import { DRAWER_MESSAGES } from '../../LoanEditorCustomFormDrawer.constants';
import EntitySelector from '../EntitySelector';

import { ContactSelectorTestIds } from './ContactSelector.testIds';

const ContactSelector = ({ contacts, disabled = false, selectedContactId = null, onSelect }) => (
  <EntitySelector
    dataTestId={ContactSelectorTestIds.CONTACT_SELECT}
    emptyText={DRAWER_MESSAGES.NO_CONTACTS_AVAILABLE}
    helperText={DRAWER_MESSAGES.CONTACT_SELECTOR_HELPER}
    isDisabled={disabled}
    label={DRAWER_MESSAGES.CONTACT_SELECTOR_LABEL}
    name="loanEditorCustomFormContactSelector"
    options={contacts}
    placeholder={DRAWER_MESSAGES.CONTACT_SELECTOR_PLACEHOLDER}
    selectedId={selectedContactId}
    onSelect={onSelect}
  />
);

ContactSelector.propTypes = {
  contacts: PropTypes.arrayOf(
    PropTypes.shape({
      id: PropTypes.string.isRequired,
      fullName: PropTypes.string,
    }),
  ).isRequired,
  onSelect: PropTypes.func.isRequired,
  disabled: PropTypes.bool,
  selectedContactId: PropTypes.string,
};

export default memo(ContactSelector);
